/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SubscribeRouteImport } from './routes/subscribe'
import { Route as SecurityRouteImport } from './routes/security'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as AnalyticsRouteImport } from './routes/analytics'
import { Route as AddRouteImport } from './routes/add'
import { Route as AccountRouteImport } from './routes/account'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as InventoryIndexRouteImport } from './routes/inventory/index'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as AuthIndexRouteImport } from './routes/auth/index'
import { Route as AuctionsIndexRouteImport } from './routes/auctions/index'
import { Route as InventoryItemIdRouteImport } from './routes/inventory/$itemId'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AuctionsNewRouteImport } from './routes/auctions/new'
import { Route as AuctionsAuctionIdIndexRouteImport } from './routes/auctions/$auctionId/index'
import { Route as AuctionsAuctionIdReviewRouteImport } from './routes/auctions/$auctionId/review'
import { Route as AuctionsAuctionIdLiveRouteImport } from './routes/auctions/$auctionId/live'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const SubscribeRoute = SubscribeRouteImport.update({
  id: '/subscribe',
  path: '/subscribe',
  getParentRoute: () => rootRouteImport,
} as any)
const SecurityRoute = SecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqRoute = FaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsRoute = AnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const AddRoute = AddRouteImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const InventoryIndexRoute = InventoryIndexRouteImport.update({
  id: '/inventory/',
  path: '/inventory/',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogIndexRoute = BlogIndexRouteImport.update({
  id: '/blog/',
  path: '/blog/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/auth/',
  path: '/auth/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuctionsIndexRoute = AuctionsIndexRouteImport.update({
  id: '/auctions/',
  path: '/auctions/',
  getParentRoute: () => rootRouteImport,
} as any)
const InventoryItemIdRoute = InventoryItemIdRouteImport.update({
  id: '/inventory/$itemId',
  path: '/inventory/$itemId',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogSlugRoute = BlogSlugRouteImport.update({
  id: '/blog/$slug',
  path: '/blog/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuctionsNewRoute = AuctionsNewRouteImport.update({
  id: '/auctions/new',
  path: '/auctions/new',
  getParentRoute: () => rootRouteImport,
} as any)
const AuctionsAuctionIdIndexRoute = AuctionsAuctionIdIndexRouteImport.update({
  id: '/auctions/$auctionId/',
  path: '/auctions/$auctionId/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuctionsAuctionIdReviewRoute = AuctionsAuctionIdReviewRouteImport.update({
  id: '/auctions/$auctionId/review',
  path: '/auctions/$auctionId/review',
  getParentRoute: () => rootRouteImport,
} as any)
const AuctionsAuctionIdLiveRoute = AuctionsAuctionIdLiveRouteImport.update({
  id: '/auctions/$auctionId/live',
  path: '/auctions/$auctionId/live',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/account': typeof AccountRoute
  '/add': typeof AddRoute
  '/analytics': typeof AnalyticsRoute
  '/dashboard': typeof DashboardRoute
  '/faq': typeof FaqRoute
  '/notifications': typeof NotificationsRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/security': typeof SecurityRoute
  '/subscribe': typeof SubscribeRoute
  '/terms': typeof TermsRoute
  '/auctions/new': typeof AuctionsNewRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/inventory/$itemId': typeof InventoryItemIdRoute
  '/auctions/': typeof AuctionsIndexRoute
  '/auth/': typeof AuthIndexRoute
  '/blog/': typeof BlogIndexRoute
  '/inventory/': typeof InventoryIndexRoute
  '/auctions/$auctionId/live': typeof AuctionsAuctionIdLiveRoute
  '/auctions/$auctionId/review': typeof AuctionsAuctionIdReviewRoute
  '/auctions/$auctionId/': typeof AuctionsAuctionIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/account': typeof AccountRoute
  '/add': typeof AddRoute
  '/analytics': typeof AnalyticsRoute
  '/dashboard': typeof DashboardRoute
  '/faq': typeof FaqRoute
  '/notifications': typeof NotificationsRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/security': typeof SecurityRoute
  '/subscribe': typeof SubscribeRoute
  '/terms': typeof TermsRoute
  '/auctions/new': typeof AuctionsNewRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/inventory/$itemId': typeof InventoryItemIdRoute
  '/auctions': typeof AuctionsIndexRoute
  '/auth': typeof AuthIndexRoute
  '/blog': typeof BlogIndexRoute
  '/inventory': typeof InventoryIndexRoute
  '/auctions/$auctionId/live': typeof AuctionsAuctionIdLiveRoute
  '/auctions/$auctionId/review': typeof AuctionsAuctionIdReviewRoute
  '/auctions/$auctionId': typeof AuctionsAuctionIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/account': typeof AccountRoute
  '/add': typeof AddRoute
  '/analytics': typeof AnalyticsRoute
  '/dashboard': typeof DashboardRoute
  '/faq': typeof FaqRoute
  '/notifications': typeof NotificationsRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/security': typeof SecurityRoute
  '/subscribe': typeof SubscribeRoute
  '/terms': typeof TermsRoute
  '/auctions/new': typeof AuctionsNewRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/inventory/$itemId': typeof InventoryItemIdRoute
  '/auctions/': typeof AuctionsIndexRoute
  '/auth/': typeof AuthIndexRoute
  '/blog/': typeof BlogIndexRoute
  '/inventory/': typeof InventoryIndexRoute
  '/auctions/$auctionId/live': typeof AuctionsAuctionIdLiveRoute
  '/auctions/$auctionId/review': typeof AuctionsAuctionIdReviewRoute
  '/auctions/$auctionId/': typeof AuctionsAuctionIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/account'
    | '/add'
    | '/analytics'
    | '/dashboard'
    | '/faq'
    | '/notifications'
    | '/privacy-policy'
    | '/security'
    | '/subscribe'
    | '/terms'
    | '/auctions/new'
    | '/auth/callback'
    | '/blog/$slug'
    | '/inventory/$itemId'
    | '/auctions/'
    | '/auth/'
    | '/blog/'
    | '/inventory/'
    | '/auctions/$auctionId/live'
    | '/auctions/$auctionId/review'
    | '/auctions/$auctionId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/account'
    | '/add'
    | '/analytics'
    | '/dashboard'
    | '/faq'
    | '/notifications'
    | '/privacy-policy'
    | '/security'
    | '/subscribe'
    | '/terms'
    | '/auctions/new'
    | '/auth/callback'
    | '/blog/$slug'
    | '/inventory/$itemId'
    | '/auctions'
    | '/auth'
    | '/blog'
    | '/inventory'
    | '/auctions/$auctionId/live'
    | '/auctions/$auctionId/review'
    | '/auctions/$auctionId'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/account'
    | '/add'
    | '/analytics'
    | '/dashboard'
    | '/faq'
    | '/notifications'
    | '/privacy-policy'
    | '/security'
    | '/subscribe'
    | '/terms'
    | '/auctions/new'
    | '/auth/callback'
    | '/blog/$slug'
    | '/inventory/$itemId'
    | '/auctions/'
    | '/auth/'
    | '/blog/'
    | '/inventory/'
    | '/auctions/$auctionId/live'
    | '/auctions/$auctionId/review'
    | '/auctions/$auctionId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  AccountRoute: typeof AccountRoute
  AddRoute: typeof AddRoute
  AnalyticsRoute: typeof AnalyticsRoute
  DashboardRoute: typeof DashboardRoute
  FaqRoute: typeof FaqRoute
  NotificationsRoute: typeof NotificationsRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  SecurityRoute: typeof SecurityRoute
  SubscribeRoute: typeof SubscribeRoute
  TermsRoute: typeof TermsRoute
  AuctionsNewRoute: typeof AuctionsNewRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  BlogSlugRoute: typeof BlogSlugRoute
  InventoryItemIdRoute: typeof InventoryItemIdRoute
  AuctionsIndexRoute: typeof AuctionsIndexRoute
  AuthIndexRoute: typeof AuthIndexRoute
  BlogIndexRoute: typeof BlogIndexRoute
  InventoryIndexRoute: typeof InventoryIndexRoute
  AuctionsAuctionIdLiveRoute: typeof AuctionsAuctionIdLiveRoute
  AuctionsAuctionIdReviewRoute: typeof AuctionsAuctionIdReviewRoute
  AuctionsAuctionIdIndexRoute: typeof AuctionsAuctionIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscribe': {
      id: '/subscribe'
      path: '/subscribe'
      fullPath: '/subscribe'
      preLoaderRoute: typeof SubscribeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/security': {
      id: '/security'
      path: '/security'
      fullPath: '/security'
      preLoaderRoute: typeof SecurityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq': {
      id: '/faq'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof FaqRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics': {
      id: '/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/add': {
      id: '/add'
      path: '/add'
      fullPath: '/add'
      preLoaderRoute: typeof AddRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory/': {
      id: '/inventory/'
      path: '/inventory'
      fullPath: '/inventory/'
      preLoaderRoute: typeof InventoryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/': {
      id: '/blog/'
      path: '/blog'
      fullPath: '/blog/'
      preLoaderRoute: typeof BlogIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/': {
      id: '/auth/'
      path: '/auth'
      fullPath: '/auth/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auctions/': {
      id: '/auctions/'
      path: '/auctions'
      fullPath: '/auctions/'
      preLoaderRoute: typeof AuctionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory/$itemId': {
      id: '/inventory/$itemId'
      path: '/inventory/$itemId'
      fullPath: '/inventory/$itemId'
      preLoaderRoute: typeof InventoryItemIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/$slug': {
      id: '/blog/$slug'
      path: '/blog/$slug'
      fullPath: '/blog/$slug'
      preLoaderRoute: typeof BlogSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auctions/new': {
      id: '/auctions/new'
      path: '/auctions/new'
      fullPath: '/auctions/new'
      preLoaderRoute: typeof AuctionsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auctions/$auctionId/': {
      id: '/auctions/$auctionId/'
      path: '/auctions/$auctionId'
      fullPath: '/auctions/$auctionId/'
      preLoaderRoute: typeof AuctionsAuctionIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auctions/$auctionId/review': {
      id: '/auctions/$auctionId/review'
      path: '/auctions/$auctionId/review'
      fullPath: '/auctions/$auctionId/review'
      preLoaderRoute: typeof AuctionsAuctionIdReviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auctions/$auctionId/live': {
      id: '/auctions/$auctionId/live'
      path: '/auctions/$auctionId/live'
      fullPath: '/auctions/$auctionId/live'
      preLoaderRoute: typeof AuctionsAuctionIdLiveRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  AccountRoute: AccountRoute,
  AddRoute: AddRoute,
  AnalyticsRoute: AnalyticsRoute,
  DashboardRoute: DashboardRoute,
  FaqRoute: FaqRoute,
  NotificationsRoute: NotificationsRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  SecurityRoute: SecurityRoute,
  SubscribeRoute: SubscribeRoute,
  TermsRoute: TermsRoute,
  AuctionsNewRoute: AuctionsNewRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  BlogSlugRoute: BlogSlugRoute,
  InventoryItemIdRoute: InventoryItemIdRoute,
  AuctionsIndexRoute: AuctionsIndexRoute,
  AuthIndexRoute: AuthIndexRoute,
  BlogIndexRoute: BlogIndexRoute,
  InventoryIndexRoute: InventoryIndexRoute,
  AuctionsAuctionIdLiveRoute: AuctionsAuctionIdLiveRoute,
  AuctionsAuctionIdReviewRoute: AuctionsAuctionIdReviewRoute,
  AuctionsAuctionIdIndexRoute: AuctionsAuctionIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
